module.exports = __webpack_public_path__ + "static/media/compra.2924ac74.svg";